import { render } from "./monitorStudents.vue?vue&type=template&id=277ab756&scoped=true"
import script from "./monitorStudents.vue?vue&type=script&lang=js"
export * from "./monitorStudents.vue?vue&type=script&lang=js"

import "./monitorStudents.vue?vue&type=style&index=0&id=277ab756&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277ab756"]])

export default __exports__